import React, { useContext } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeDishPositionContext,
	IChangeDishPositionContext,
} from '../../../../changeDishPositionState/changeDishPositionContext';
import { updateDishPositionsV2 } from 'backend/dishes';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		typeOfModalWindow,
		positionsData,
		IDSelectedRestaurant,
		IDSelectedCategory,
		IDSelectedSubCategory,
		selectedAdditionalRestaurants,
		fetchedRestaurants,
	} = useContext<IChangeDishPositionContext>(ChangeDishPositionContext);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const restaurantsToApplyChanges = IDSelectedRestaurant
		? fetchedRestaurants.filter((el) => [IDSelectedRestaurant, ...selectedAdditionalRestaurants].includes(el.id))
		: [];

	const handleRedirect = () => {
		history.push('/menu-v2/dishes');
	};

	const handleConfirm = async () => {
		if (positionsData && IDSelectedRestaurant && IDSelectedCategory && IDSelectedSubCategory) {
			try {
				const restaurantIds = [IDSelectedRestaurant, ...selectedAdditionalRestaurants];
				const dishIds = positionsData.map((el) => el.id);
				showLoader();
				await updateDishPositionsV2({
					restaurantIds,
					subCategoryId: IDSelectedSubCategory,
					dishIds,
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSave' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="saveChangeOnRestaurants"
					typeOfInfoIcon="withoutIcon"
					additionalContent={
						!!restaurantsToApplyChanges?.length && (
							<div className={style.itemsList}>
								{restaurantsToApplyChanges.map((el) => (
									<Text
										key={el.id}
										translationKey={el.name}
										theme="secondaryLight"
										size="l"
										weight="bold"
									/>
								))}
							</div>
						)
					}
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="errorWhileSaving"
				/>
			)}
		</div>
	);
};
